// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rGP3c","colMin":"styles_colMin__3rj7G"};